<template>
  <div class="ruta navMargin">
    <NavBar :transparent-on-top="true" active="watch"></NavBar>
    <Carousel v-if="slides.array.length > 0" :slides="slides.array" />
    <br>
    <div class="noMeLaContainer">
      <vs-row>
        <vs-col w="12">
          <!-- SECCIÓN: Categorías -->
          <!-- <vs-row class="section">
            <vs-col w="12"><b class="section-title"> <i class='bx pad bxs-tag-alt'></i> Categorías</b></vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" lg="2" sm="4" class="colMargin" v-for="categoria in categoriesAvailable" :key="categoria.id">
              <vs-card type="1" style="width: 90%;" class="centrarButton">
                <template #title><b></b></template>
                <template #text><p class="centrar"> <b>{{categoria.nombreCorto}}</b> </p></template>
              </vs-card>
            </vs-col>
          </vs-row> -->

          <!-- TODO: SECCIÓN: Continúa viendo -->
          <!-- <vs-row class="section continue-watching">
            <vs-col w="12"><b class="section-title"> <i class='bx pad bxs-playlist'></i> Continuar viendo...</b></vs-col>
            <vs-card-group w="12">
              <vs-card>
                <template #img>

                  <img src="https://dash.fembed.com/asset/userdata/355412/poster/j/dg/jdg8xudgw7nn3xq.png" alt="">
                </template>
                <template #interactions>
                  <vs-button class="btn-chat" color="#fffff" shadow primary>
                    <span class="span">
                      Temporada 2
                    </span>
                  </vs-button>
                </template>
                <template #text>
                  <p></p>
                </template>
                <template #title>
                <h3>E1 - La loba y sus problemas</h3>
              </template>
              </vs-card>
            </vs-card-group>
          </vs-row> -->

          <!-- SECCIÓN: Series recientemente añadidos -->
          <vs-row class="section">
            <vs-col w="12"><b class="section-title"> <i class='bx pad bx-plus'></i> Shows recientemente añadidos</b></vs-col>
            <vs-card-group class="remove-scroll" w="12">
              <div class="colMargin" v-for="show in landing.recentShows" :key="show.idEpisodio">
                <vs-card type="2" @click="openShowInfo(null, show.nombre, show.url, show.poster_vertical, show.poster_horizontal)" class="landingCard"> <!-- type="4"; goToLink(`https://videnti.co/watch/${show.url}`) -->
                  <template #title>
                    <!-- <h3 class="episode-name-cut-legacy">{{show.nombre}}</h3> -->
                    <b>{{ show.nombre }}</b>
                  </template>
                  <template #img>
                    <img :src="show.poster_vertical" alt="" @error="imageUrlAlt($event, true)" width="1080px">
                    <!-- v-if="show.poster_horizontal != null || show.poster_horizontal === ''"  -->
                    <!-- <img v-else :src="`https://i.imgur.com/Zx6wTMp.png`" alt="" @error="imageUrlAlt" width="1080px"> -->
                  </template>
                  <template #text><p></p></template>
                </vs-card>
              </div>
            </vs-card-group>
          </vs-row>

          <!-- SECCIÓN: Recientemente añadidos -->
          <!-- <vs-row class="section">
            <vs-col w="12"><b class="section-title"> <i class='bx pad bx-plus'></i> Episodios recientemente añadidos</b></vs-col>
            <EpisodesCardsSingleSeason :episodes="recentEpisodes" :show-season-number="true" :open-show-info="openShowInfo" ></EpisodesCardsSingleSeason>
          </vs-row> -->

          <!-- SECCIÓN: Editor Picks -->
          <vs-row>
            <vs-col w="12"><b class="section-title"> <i class='bx pad bxs-star'></i> Elección del Editor</b></vs-col>
            <vs-card-group class="remove-scroll" w="12">
              <div class="colMargin" v-for="show in landing.editorPicks" :key="show.id">
                <vs-card type="2" @click="openShowInfo(1, show.nombre, show.url, show.poster_vertical, show.poster_horizontal)" class="landingCard">
                  <template #title>
                    <b>{{ show.nombre }}</b>
                  </template>
                  <template #img>
                    <img :src="show.poster_vertical" alt="" @error="imageUrlAlt($event, true)">
                  </template>
                  <template #text>  <p></p></template>
                </vs-card>
              </div>
            </vs-card-group>
          </vs-row>

          <!-- SECCIÓN: Más recomendados por la comunidad -->
          <vs-row>
            <vs-col w="12"><b class="section-title"> <i class='bx pad bxs-heart'></i> Más recomendados por la comunidad {{ landing.favoriteShows.currentInterval }}</b></vs-col>
            <vs-card-group class="remove-scroll" w="12">
              <div class="colMargin" v-for="show in landing.favoriteShows.shows" :key="show.id">
                <vs-card type="2" @click="openShowInfo(1, show.nombre, show.url, show.poster_vertical, show.poster_horizontal)" class="landingCard">
                  <template #title>
                    <b>{{ show.nombre }}</b>
                  </template>
                  <template #img>
                    <img :src="show.poster_vertical" :alt="`Póster de ` + show.nombre" @error="imageUrlAlt($event, true)">
                  </template>
                  <template #text><p></p></template>
                  <template #interactions>
                    <vs-button class="btn-chat" shadow danger>
                      <i class='bx bx-heart'></i><span style="margin-left: 5px">{{ show.count_liked }}</span>
                    </vs-button>
                  </template>
                </vs-card>
              </div>
            </vs-card-group>
          </vs-row>
        </vs-col>
        <!-- <vs-col w="12" justify="center" style="display:flex; margin: 15px 0">
          <a href="https://delivery.taroads.com/pub?id=183" target="_blank" style="text-align: center">
            <img src="../assets/help-us.png" alt="Ayúdanos a sostener Videnti. Haz click aquí." style="width: 100%; max-width: 900px;" />
          </a>
        </vs-col> -->
      </vs-row>
    </div>
    <Footer></Footer>


    <!-- Dialog -->
    <vs-dialog scroll full-screen overflow-hidden v-model="activeMoreInfo" class="landingDialog" :loading="!dialog.loaded" @close="$router.replace({ path: $route.path });">
      <!-- <template #header>
        <h1 class="not-margin">
          <b>{{ dialog.title }} <span class="badge tip top" v-if="dialog.typeSerie !== ''">{{ dialog.typeSerie }}</span></b>
        </h1>
      </template> -->
      <vs-row style="padding-left: 4%; padding-right: 4%">
        <vs-col w="2" sm="3" xs="12" lg="2" class="sticky-sidebar">
          <img class="poster_dialog" :src="dialog.imagev" alt="Poster de la serie" />
          <vs-row w="12" align="center" justify="center">
            <!-- <vs-tooltip bottom>
              <vs-button size="default" icon color="danger" border :active="dialog.mini.recommended === true" @click="markRecommended" @mouseout="let tmp = document.createElement('input'); tmp.style.position = 'fixed';  document.body.appendChild(tmp);  tmp.focus();  document.body.removeChild(tmp);">
                <i class='bx bxs-heart' ></i>
              </vs-button>
              <template #tooltip>
                {{ dialog.mini.recommended ? "Ya está en tus favoritos" : "Marcar como favorito" }}
              </template>
            </vs-tooltip> -->
          </vs-row>
          <vs-button block size="large" class="centrarButton" :href="dialog.firstEpisodeLink">
            <i class='bx bxs-right-arrow button-margin-dialog'></i> Ver
          </vs-button>
          <vs-button block size="large" danger class="centrarButton" :href="dialog.serieLink">
            <i class='bx bx-list-ul button-margin-dialog'></i> Episodios
          </vs-button>
          <div class="showWhenSmall"></div>
        </vs-col>

        <vs-col w="7" sm="9" xs="12" lg="10" class="dialog-content-container">
          <vs-row style="margin-bottom: 1rem" align="center">
            <vs-col xs="12" w="8">
              <h1 class="not-margin">
                <b>{{ dialog.title }} <span class="badge tip top" v-if="dialog.typeSerie !== ''">{{ dialog.typeSerie }}</span></b>
              </h1>
            </vs-col>
            <vs-col xs="12" w="4">
              <vs-button-group>
                <vs-button class="button-tab-dialog" size="l" flat :active="dialog.currentTab === 'detail'" @click="dialogSwitch('detail')">
                  Detalles
                </vs-button>
                <vs-button class="button-tab-dialog" size="l" flat :active="dialog.currentTab === 'episodes'" @click="dialogSwitch('episodes')">
                  Episodios
                </vs-button>
                <!-- <vs-button class="button-tab-dialog" size="l" flat :active="dialog.currentTab === 'suggest'" @click="dialogSwitch('suggest')">
                  Sugerencias
                </vs-button> -->
              </vs-button-group>
            </vs-col>
          </vs-row>
          <!-- <br> -->
          <div v-if="dialog.currentTab === 'detail'">
            <vs-row>
              <vs-col w="12" style="margin-bottom: 1rem">
                {{ dialog.description }}
              </vs-col>
              <vs-col xs="12" lg="6" w="6">
                <b class="dialog-subtitle">Información adicional</b>
                <hr class="dialog-subtitle-line">
                <vs-row align="center">
                  <vs-col w="4"> <div class="dialog-additional-info-tite">Estado</div> </vs-col>
                  <vs-col w="8"> {{ getStatus(dialog.content.status) }} </vs-col>
                </vs-row>
                <vs-row align="center" v-if="dialog.publishers.length > 0" class="attribute-margin">
                  <vs-col w="4"> <div class="dialog-additional-info-tite">Editor</div> </vs-col>
                  <vs-col w="8">
                    <div style="display: flex; align-items: center; justify-content: left; flex-wrap: wrap;" v-if="dialog.publishers.length === 1">
                      <vs-avatar size="35" style="margin-right: 1%">
                        <i class='bx bx-user'></i>
                      </vs-avatar>
                      {{ dialog.publishers[0].nombre }}
                    </div>
                  </vs-col>
                </vs-row>
                <vs-row align="center" class="attribute-margin" v-if="dialog.content.atribucion">
                  <vs-col w="4"> <div class="dialog-additional-info-tite">Atribución</div> </vs-col>
                  <vs-col w="8"> {{ dialog.content.atribucion }} </vs-col>
                </vs-row>
              </vs-col>
              <vs-col xs="12" lg="6" w="6">
                <vs-row>
                  <vs-col w="12" style="margin-bottom: 1rem" v-if="dialog.external.downloadingSites.length > 0">
                    <b class="dialog-subtitle">Sitios de descarga</b>
                    <hr class="dialog-subtitle-line">
                    <vs-card v-for="site in dialog.external.downloadingSites" :key="site.id" type="1" style="width: 100%; margin-bottom: 1rem;" class="card-remove-max-width service-card" @click="goToLink(site.url, true)">
                      <template #title><b></b></template>
                      <template #text>
                        <img :src="site.image" style="height: 2rem; margin: auto; width: 100%; object-fit: contain;" alt="">
                      </template>
                    </vs-card>
                  </vs-col>
                  <vs-col w="12" v-if="dialog.external.streamingServices.length > 0">
                    <b class="dialog-subtitle">Sitios legales</b>
                    <hr class="dialog-subtitle-line">
                    <vs-card v-for="site in dialog.external.streamingServices" :key="site.id" type="1" style="width: 100%; margin-bottom: 1rem;" class="card-remove-max-width service-card" @click="goToLink(site.url, true)">
                      <template #title><b></b></template>
                      <template #text>
                        <img :src="site.image" style="height: 2rem; margin: auto; width: 100%; object-fit: contain;" :alt="site.name">
                      </template>
                    </vs-card>
                  </vs-col>
                </vs-row>
              </vs-col>
            </vs-row>
          </div>

          <div v-if="dialog.currentTab === 'episodes' && dialog.loadedSeasons === true">
            <div v-if="dialog.seasons.length === 0 || dialog.seasons === null">
              Lo sentimos, no hay episodios disponibles de esta serie ahora mismo.
            </div>
            <div v-else>
              <div style="display: flex; justify-content: center;">
                <vs-select placeholder="" v-model="dialog.currentSeason">
                  <vs-option
                      v-for="(season, index) in dialog.seasons"
                      :label="'Temporada ' + season.number"
                      :value="index"
                      :key="season.id">
                    Temporada {{ season.number }}
                  </vs-option>
                </vs-select>
              </div>
              <EpisodesCardsSingleSeason :episodes="dialog.seasons[dialog.currentSeason].episodes" :series-url="dialog.url" :season-number="dialog.seasons[dialog.currentSeason].number"></EpisodesCardsSingleSeason>
            </div>
          </div>
        </vs-col>
      </vs-row>
      <!-- <template #footer>
        <div class="footer-dialog hideWhenSmall">
          <vs-row>
            <vs-col w="6">
              <vs-button danger block size="large" class="noventa centrarButton" :href="dialog.serieLink"><i class='bx bx-list-ul'></i> Episodios</vs-button>
            </vs-col>
            <vs-col w="6">
              <vs-button flat block warn disabled size="large" class="noventa centrarButton"><i class='bx bxs-bookmark-plus'></i> Añadir </vs-button> </vs-col>
            <vs-col w="12">
              <vs-button block size="large" class="centrarButton" :href="dialog.firstEpisodeLink"><i class='bx bxs-right-arrow'></i> Ver </vs-button>
            </vs-col>
          </vs-row>
        </div>
      </template> -->
    </vs-dialog>
  </div>
</template>

<script>
import api from '@/services/api';
import { getImageSource, preloadImage } from '@/utils/helpers';

import axios from "axios";
import Footer from "@/views/Footer";
import EpisodesCardsSingleSeason from "@/components/EpisodesCardsSingleSeason";
import NavBar from "../components/NavBar";
import Carousel from "@/components/Carousel.vue";

export default {
  name: "LandingPageAnime",
  components: {Carousel, NavBar, EpisodesCardsSingleSeason, Footer},
  data () {
    return {
      slides: {
        index: 1,
        array: [],
        interval: null
      },
      activeMoreInfo: false,
      dialog: {
        content: {},
        title: "",
        description: "Cargando...",
        image: "",
        imagev: "",
        firstEpisodeLink: "",
        serieLink: "",
        publishers: [],
        typeSerie: "",
        url: "",
        seasons: [],
        currentTab: "detail",
        currentSeason: 0,
        loaded: false,
        loadedSeasons: false,
        external: {
          downloadingSites: [],
          streamingServices: []
        },
        mini: {
          recommended: false
        }
      },
      slidesAnime: [],
      categoriesAvailable: {},
      interval: null,
      recentEpisodes: [],
      landing: {
        categories: [],
        recentEpisodes: [],
        favoriteShows: {
          currentInterval: "hoy",
          shows: []
        },
        editorPicks: [],
        recentShows: []
      }
    }
  },
  methods: {
    openShowInfo(id, title, url, poster_vertical = null, poster_horizontal = null) {
      // this.$router.replace({ path: this.$route.path, query: { d: url } });
      this.$router.push(
          { name: "animedetail",
            params: {
              name: url,
              title,
              poster_vertical,
              poster_horizontal
            }
          });

      this.dialog.currentTab = "detail";
      this.dialog.loadedSeasons = false;
      this.dialog.loaded = false;
      this.dialog.image = "";
      this.dialog.description = "";
      this.dialog.currentSeason = 0;
      this.dialog.seasons = [];
      this.dialog.external.downloadingSites = [];
      this.dialog.external.watchLegalSites = [];
      this.dialog.title = title;
      axios.get('https://api.videnti.co/tv/getInfo/' + url)
          .then(response => {
            if (!response.data[0]) { window.location = '../?error=SERIE_NO_EXISTE'; }
            this.dialog.title = response.data[0].nombre;
            this.dialog.content = response.data[0];
            this.dialog.description = response.data[0].descripcion;
            this.dialog.image = response.data[0].poster_horizontal;
            this.dialog.imagev = response.data[0].poster_vertical;
            this.dialog.firstEpisodeLink = window.location.origin + "/watch/" + url + "/1/1";
            this.dialog.serieLink = window.location.origin + "/watch/" + url + "/";
            this.dialog.url = url;
            this.dialog.typeSerie = response.data[0].tipo;

            this.setDialogBackground();

            /* switch (response.data[0].status) {
              case 0:
                this.status = "En emisión"
                break;
              case 1:
                this.status = "Finalizado";
                break;
              case 2:
                this.status = "Hiatus";
                break;
            }
            this.poster = response.data[0].poster_vertical;
            this.idSerie = response.data[0].idSerie; */

            this.dialog.loaded = true;
          }).catch(error => console.log(error));
      axios
          .get('https://api.videnti.co/publishersBySeriesUrl/' + url)
          .then(resPublishers => {
            this.dialog.publishers = resPublishers.data;
          });
      axios
          .get('https://api.videnti.co/tv/getDownloadingSites/' + url)
          .then(res => { this.dialog.external.downloadingSites = res.data });
      axios
          .get('https://api.videnti.co/tv/getStreamingServices/' + url)
          .then(res => { this.dialog.external.streamingServices = res.data });
      this.activeMoreInfo = true;
    },
    setDialogBackground() {
      if (!this.activeMoreInfo) return;
      let selector;

      if (document.body.clientWidth > 600) {
        selector = (this.dialog.image == null || this.dialog.image === "") ? `rgb(25,25,25)` : `linear-gradient(to right, rgba(25,25,25,0), rgba(25,25,25,0.9), rgba(25,25,25,1), rgba(25,25,25,1)), url("${this.dialog.image}")`;
        // if (this.dialog.image != null && this.dialog.image !== "") { selector = `linear-gradient(to right, rgba(25,25,25,0), rgba(25,25,25,0.9), rgba(25,25,25,1), rgba(25,25,25,1)), url("${this.dialog.image}")` } else { selector = `linear-gradient(to right, rgba(31, 37, 219, 0.3), rgba(25,25,25,0.9), rgba(25,25,25,1), rgba(25,25,25,1))` }

        document.querySelector('.landingDialog > .vs-dialog > .vs-dialog__content').style.background = "";
        document.querySelector('.landingDialog > .vs-dialog').style.background = selector;
        document.querySelector('.landingDialog > .vs-dialog').style.backgroundSize = "cover";
      } else {
        if (this.dialog.image != null || this.dialog.image !== "") {
          selector = `linear-gradient(to bottom, rgba(25,25,25,0), rgba(25,25,25,0.9), rgba(25,25,25,1), rgba(25,25,25,1)), url("${this.dialog.image}")`
        } else {
          selector = `linear-gradient(to bottom, rgba(31, 37, 219, 0.3), rgba(25,25,25,0.9), rgba(25,25,25,1), rgba(25,25,25,1))`
        }
        document.querySelector('.landingDialog > .vs-dialog').style.background = "rgb(25,25,25)";
        document.querySelector('.landingDialog > .vs-dialog > .vs-dialog__content').style.background = selector;
        document.querySelector('.landingDialog > .vs-dialog > .vs-dialog__content').style.backgroundAttachment = "local, local";
      }
    },
    checkIfLink(link, altLink) {
      if (link) {
        window.open(link);
      } else if (altLink) {
        window.open(altLink);
      }
    },
    imageUrlAlt(event, tall) {
      if (tall) {
        event.target.src = "https://storage.googleapis.com/balde-1/various/placeholders/noimg_y.png"
      } else {
        event.target.src = "https://storage.googleapis.com/balde-1/various/placeholders/noimg_x.png"
      }
      // event.target.src = "https://i.imgur.com/Zx6wTMp.png"
    },
    goToLink(link, blank) {
      /* if (blank) { window.open(link); } else { window.location = link; } */
      blank ? window.open(link) : window.location = link;
    },
    changeInterval(oldInterval) {
      let interval;
      switch (oldInterval) {
        case "day": interval = "week"; this.landing.favoriteShows.currentInterval = "esta semana"; break;
        case "week": interval = "year"; this.landing.favoriteShows.currentInterval = "este año"; break;
        default: return;
      }
      axios.get('https://api.videnti.co/tv/getMostFavorited?interval=' + interval)
          .then(res => {
            this.landing.favoriteShows.shows = res.data;
            this.landing.favoriteShows.shows.forEach(show => {
              show.poster_horizontal = getImageSource(show.images, 'poster_horizontal', 'sm', show.poster_horizontal)
              show.poster_vertical = getImageSource(show.images, 'poster_vertical', 'sm', show.poster_vertical)
            });
            if (res.data.length === 0) { this.changeInterval(interval); }
          })
    },
    dialogSwitch(value) {
      let url = this.dialog.url;
      this.dialog.currentTab = value;
      switch (value) {
        case "episodes":
          if (this.dialog.seasons.length !== 0 && this.dialog.loadedSeasons) { console.log('Episodes already loaded.'); break; }
          this.dialog.loaded = false;
          axios
              .get('https://api.videnti.co/tv/getSeasonsAndEpisodes/' + url)
              .then(res => {
                this.dialog.seasons = res.data;
                this.dialog.loadedSeasons = true;
                this.dialog.loaded = true;
              });
          break;
        case "suggestion":
          // TODO
          break;
      }
    },
    goToEpisode(url, temporada, episodio) {
      window.location = window.location.origin + window.location.pathname + "/" + url + "/" + temporada + "/" + episodio;
    },
    getStatus(id) {
      switch (id) {
        case 0: return "En emisión";
        case 1: return "Finalizado";
        case 2: return "Hiatus";
        default: return "Otro...";
      }
    }
  },
  async created() {
    const loading = this.$vs.loading({ background: '#000', color: '#fff', text: 'Cargando...' });
    if (this.$route.query.d) this.openShowInfo(null, null, this.$route.query.d);

    try {
      const res = await api.get('/tv/hero');

      this.slides.array = res.data.data.map(item => ({
        id: item.id,
        title: item.title,
        description: item.description,
        button_text: item.button_text,
        button_url: item.button_url,

        // Estandarizamos las imágenes de desktop
        bgDesktop: getImageSource(item.images, 'bg_desktop', 'hero_bg_desk_lg'),
        fgDesktop: getImageSource(item.images, 'fg_desktop', 'original'),

        // Estandarizamos las imágenes de mobile
        bgMobile: getImageSource(item.images, 'bg_mobile', 'hero_bg_mob_lg'),
        fgMobile: getImageSource(item.images, 'fg_mobile', 'original'),
      }));

      // Preload opcional (aunque el navegador ya es bueno haciendo esto con las etiquetas CSS)
      this.slides.array.forEach(slide => {
        if (slide.bgDesktop) preloadImage(slide.bgDesktop);
        if (slide.bgMobile) preloadImage(slide.bgMobile);
      });

    } catch (error) {
      this.$vs.notification({
        progress: 'auto',
        color: "danger",
        title: 'Ocurrió un pequeño error',
        text: `No se ha podido cargar el carrusel principal.`
      });
      console.log(error);
    }

    /* await axios
        .get('https://api.videnti.co/tv/getRecentAddedEpisodes')
        .then(res => {
          this.recentEpisodes = res.data;
          this.landing.recentEpisodes = res.data;
        }); */
    /* await axios
        .get('https://api.videnti.co/availableCategories')
        .then(resCat => {
          this.categoriesAvailable = resCat.data;
          this.landing.categories = resCat.data;
        }); */

    await axios
        .get('https://api.videnti.co/tv/getRecentAddedShows')
        .then(res => {
          this.landing.recentShows = res.data;
          this.landing.recentShows.forEach(show => {
            show.poster_horizontal = getImageSource(show.images, 'poster_horizontal', 'sm', show.poster_horizontal)
            show.poster_vertical = getImageSource(show.images, 'poster_vertical', 'sm', show.poster_vertical)
          });
        });
    await axios
        .get('https://api.videnti.co/tv/getCollection/editors-picks')
        .then(resFeatured => {
          this.landing.editorPicks = resFeatured.data.shows;
          this.landing.editorPicks.forEach(show => {
            show.poster_horizontal = getImageSource(show.images, 'poster_horizontal', 'sm', show.poster_horizontal)
            show.poster_vertical = getImageSource(show.images, 'poster_vertical', 'sm', show.poster_vertical)
          });
        });
    await axios.get('https://api.videnti.co/tv/getMostFavorited?interval=day')
        .then(res => {
          this.landing.favoriteShows.shows = res.data;
          this.landing.favoriteShows.shows.forEach(show => {
            show.poster_horizontal = getImageSource(show.images, 'poster_horizontal', 'sm', show.poster_horizontal)
            show.poster_vertical = getImageSource(show.images, 'poster_vertical', 'sm', show.poster_vertical)
          });
          if (res.data.length === 0) { this.changeInterval("day"); }
        });

    loading.close();
    window.addEventListener("resize", this.setDialogBackground);
  },
  beforeDestroy () {
    clearInterval(this.interval);
  },
  metaInfo() {
    return {
      title: 'Videnti - Series, Anime y Películas online',
      htmlAttrs: {
        lang: 'es'
      },
      meta: [
        { charset: 'utf-8' },
        { name: 'description', content: 'Disfruta tus series, animes y películas favoritas de forma gratuita y en alta calidad en Videnti. ¿Qué esperas? ¡Entra ahora!' }
      ]
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.setDialogBackground);
  },
}
</script>

<style scoped>
.ruta {
  margin-top: 30px;
}

.section {
  margin-bottom: 20px;
}

.slideshow-container {
  width: 85%;
  /* height: max-content;
  overflow:auto; */
  margin: auto;
  position: relative;
}

@media only screen and (max-width: 975px) {
  .slideshow-container {
    width: 100%;
  }
}

/* Hide the images by default */
.mySlides {
  /* display: none; */
  opacity: 0;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

/* Next & previous buttons */
.arrow {
  z-index: 30;
}

.prev, .next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  margin-top: -22px;
  padding: 16px;
  color: white;
  font-weight: bold;
  font-size: 18px;
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  user-select: none;
}

/* Position the "next button" to the right */
.next {
  right: 0;
  border-radius: 3px 0 0 3px;
}

/* On hover, add a black background color with a little bit see-through */
.prev:hover, .next:hover {
  background-color: rgba(0,0,0,0.8);
}

/* Caption text */
.text {
  color: #f2f2f2;
  font-size: 15px;
  /* padding: 8px 12px; */
  position: absolute;
  bottom: 0px;
  width: 100%;
  text-align: center;
}

.text h3 {
  margin-bottom: 0;
}

/* Number text (1/3 etc) */
.numbertext {
  color: #f2f2f2;
  font-size: 12px;
  padding: 8px 12px;
  position: absolute;
  top: 0;
}

/* The dots/bullets/indicators */
.dot {
  cursor: pointer;
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}

.active, .dot:hover {
  background-color: #717171;
}

/* Fading animation */
.fade {
  /* -webkit-animation-name: fade;
  -webkit-animation-duration: 1.5s;
  animation-name: fade;
  animation-duration: 1.5s; */
  /* -webkit-transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -o-transition: opacity 1s ease-in-out; */
}

@-webkit-keyframes fade {
  from {opacity: .4}
  to {opacity: 1}
}

@keyframes fade {
  from {opacity: .4}
  to {opacity: 1}
}

.centrarButton {
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

@media only screen and (max-width: 645px) {
  .noMeLaContainer {
    margin-left: 2% !important;
    margin-right: 2% !important;
  }
}
.noMeLaContainer {
  margin-left: 10px;
  margin-right: 10px;
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

.bx.pad {
  padding-right: 20px;
}

.vs-button--block.noventa {
  width: 95%;
  text-align: center;
}

.dialog-additional-info-tite {
  font-weight: bold;
  padding-left: 0.5rem;
}

.attribute-margin {
  margin-top: 0.4rem;
}
</style>

<style>
.type-2 .vs-card {
  margin-left: auto;
  margin-right: auto;
  width: 95% !important;
}

.colMargin {
  margin-bottom: 2%;
  /* margin-top: 2%; */
}

.vs-card__text {
  width: 100%;
}

input.vs-input {
  width: 100%;
  height: 40px;
}

.vs-dialog {
  /* background: #303030; */
  background: rgb(25,25,25);
  /* background: rgb(0, 0, 0); */
  color: aliceblue;
}

.vs-dialog__close {
  --vs-color: var(--vs-primary);
}

.vs-dialog--scroll .vs-dialog__content {
  max-height: calc(95vh - 100px) !important;
  /* max-height: initial; */
}

.badge {
  display: inline-block;
  font-size: .9rem;
  border-radius: 5px;
  padding: 1px 5px;
  color: #fff;
  margin-right: 0;
  background-color: #42b983;
  cursor: default;
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.badge.top {
  vertical-align: top;
}

.badge.middle {
  vertical-align: middle;
}

@media only screen and (max-width: 645px) {
  .vs-dialog--scroll .vs-dialog__content {
    /* max-height: calc(80vh - 25px) !important; */
    max-height: calc(100vh - 90px);
    /* max-height: unset; */
    scrollbar-width: none;
  }

  .vs-dialog--scroll .vs-dialog__content::-webkit-scrollbar {
    display: none;
  }
}

b.section-title {
  padding-left: 8px;
  font-size: large;
}

.poster_dialog {
  width: 100%;
}

@media only screen and (max-width: 645px) {
  .poster_dialog {
    display: block;
    width: 50%;
    margin-left: auto;
    margin-right: auto;
  }
}

@media only screen and (min-width: 600px) {
  .dialog-content-container {
    padding-left: 2rem;
  }
}
</style>

<style>
.landingCard > .vs-card {
  /* height: 250px; */
  height: 23vh;
}

.landingCard > .vs-card > .vs-card__img > img {
  object-fit: cover;
  /* height: 250px; */
  height: 23vh;
  width: 100%;
}

@media only screen and (min-width: 645px) {
  .landingCard > .vs-card {
    /* min-height: 250px; */
    min-height: 15.6rem;
    width: auto;
  }
  .landingCard > .vs-card > .vs-card__img > img {
    /* min-height: 250px; */
    min-height: 15.6rem;
    width: auto;
  }
}

@media only screen and (max-width: 645px) {
  .landingCard > .vs-card {
    min-height: 200px;
  }
  .landingCard > .vs-card > .vs-card__img > img {
    min-height: 200px;
  }
  .vs-card__group-prev {
    display: none !important;
  }
  .vs-card__group-next {
    display: none !important;
  }
  .vs-card__group-cards::-webkit-scrollbar {
    height: 0;
    width: 0;
  }
}

.vs-card__group .vs-card__group-cards .vs-card-content.type-2.landingCard {
  min-width: 130px; /* before auto */
  margin-left: 10px;
}

.landingDialog .vs-dialog .vs-dialog__close {
  background: #303030 !important;
}

.force-aspect-ratio .vs-card .vs-card__img img {
  object-fit: cover;
  width: 100%;
  height: 200px;
}

.vs-card-content.type-4 .vs-card {
  max-width: none !important;
}

.vs-card-content.type-4 .vs-card__text {
  backdrop-filter: none !important;
}

i.button-margin-dialog {
  margin-right: 0.5rem;
}

.vs-dialog .vs-dialog__content {
  /* margin-top: 2rem */
  padding-top: 2rem
}

.not-margin {
  margin-bottom: 0;
}

.button-tab-dialog .vs-button__content {
  font-size: 1rem;
}

.card-remove-max-width .vs-card {
  max-width: none;
}

.service-card .vs-card .vs-card__text {
  text-align: center;
}

@media all and (min-width: 600px) {
  .sticky-sidebar {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    align-self: flex-start;
  }
}
</style>
